import React from "react";

const CategoryRow = ({
  category,
  isExpanded,
  onToggle,
  onEdit,
  onDelete,
  onCheckboxClick,
  draggableProps,
  dragHandleProps,
  innerRef,
  isDraggable,
  isClubPremium,
}) => {
  const hasSubcategories = category.subcategories.length > 0;

  return (
    <tr className={`category-row hoverable-row ${isDraggable ? 'draggable-row' : ''}`} style={{ cursor: 'pointer' }} onClick={hasSubcategories ? onToggle : undefined} ref={innerRef} {...draggableProps} {...dragHandleProps}>
      <td>
        <div
          className={`icheckbox_square-orange icheck-item ${category.checked ? 'checked' : ''} ${category.default ? 'disabled' : ''}`}
          onClick={onCheckboxClick}
        >
          <input
            id={`checkbox${category.id}`}
            className="i-checks icheck-input"
            type="checkbox"
            checked={category.checked}
            readOnly
          />
        </div>
      </td>
      <td>
        {isDraggable && <i className="fa fa-bars drag_handle ui-sortable-handle add-margin-right-5"></i>}
        <span style={{ fontSize: 18 }}>{category.name.length > 60 ? category.name.slice(0, 60) + '…' : category.name} </span>
        {hasSubcategories && (
          <span style={{ fontSize: 15 }}>• {category.subcategories.length} submenus</span>
        )}
        {!category.system_field && isClubPremium && (
          <span className="actions">
            <span> • </span>
            <a onClick={(e) => { e.stopPropagation(); onEdit(); }} className="edit-action add-margin-right-5">
              <span className="fa fa-pencil-square-o" />
              {window.I18n.t('mobile_app_dashboard.menu.edit')}
            </a>
            {!category.default && (
              <>
                <span>• </span>
                <a onClick={(e) => { e.stopPropagation(); onDelete(); }} className="remove-action">
                  <span className="fa fa-trash-o" />
                  {window.I18n.t('mobile_app_dashboard.menu.remove')}
                </a>
              </>
            )}
          </span>
        )}
      </td>
      <td>
        {hasSubcategories > 0 && (
          <span className={isExpanded ? "arrow arrow-up" : "arrow arrow-down"}></span>
        )}
      </td>
    </tr>
  );
};

export default CategoryRow;
